import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//import Slider from "react-slick";
import '../css/homeFeatures.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
//import Restblogo from '../img/logo_restb.png';
import Select from 'react-select';
import {toProperCase} from 'components/util'
import * as searchActions from 'actions/search';

class HomeFeatures extends React.Component {

    constructor(props) {
        super(props);
        this.state = { selections: [] }
    }

    /* componentWillReceiveProps(nextProps) {
        if (this.props.features !== nextProps.features) {
            if (this.state.selections.length < 10) {
                this.slider.slickGoTo(0, true);
            }
        }
    }

    doSelect = (feature) => {
        const index = this.state.selections.indexOf(feature);
        if (index !== -1) {
            this.setState({selections: this.state.selections.filter(f => f !== feature)},
                () => this.props.onFeatureSelected(this.state.selections)
            );
        }
        else {
            this.setState({selections: [...this.state.selections, feature]},
                () => this.props.onFeatureSelected(this.state.selections)
            );
        }
    } */

    handleReactSelectChange = (val, name) => {
        let parameters = Object.assign({}, this.props.searchParameters_Redux);
        if (val && ((Array.isArray(val) && val.length > 0) || (!Array.isArray(val) && val.value && val.value !== ""))) {
            if(Array.isArray(val)){
                var aVal = [];
                val.map(item => {aVal.push(item.value);return null;});
                parameters[name] = aVal;
            }
            else{
                parameters[name] = val.value;
            }
        }
        else {
            delete parameters[name];
        }
        parameters.page_number = 1;
        parameters.skip = 0;
        this.props.searchActions.updateParameters(parameters);
    }

    render() {
        /* const { features, fullScreen } = this.props;
        const { selections } = this.state;
        const featuresSorted = [...new Set([...selections,...features])]; // put selections first and remove duplicates
        const settings = {
            dots: false,
            infinite: false,
            speed: 500,
            slidesToShow: 10,
            slidesToScroll: 4,
            arrows: true,
            variableWidth: true
        }; */

        const { features, searchParameters_Redux } = this.props;

        var selected = [];
        if(searchParameters_Redux && searchParameters_Redux.homeFeatures && searchParameters_Redux.homeFeatures.length > 0){
            searchParameters_Redux.homeFeatures.map((f) => {
                selected.push({ value: f, label: f.substr(0,1).toUpperCase() + f.substr(1).toLowerCase().replace(/_/g,' ') });
                return null;
            });
        }

        /* return (
            <div style={{ display: fullScreen ? 'block': 'none'}}>
                <div> 
                    <div className="features_slider">
                        <div className="restb_logo_box"><img src={Restblogo} alt="" /></div> 
                        <Slider {...settings} ref={slider => (this.slider = slider)} >
                            {featuresSorted.map((feature, i) => {
                                return <div key={i} className={'homeFeatures' + (selections.indexOf(feature) !== -1 ? ' selected' : '')}
                                    onClick={() => this.doSelect(feature)}>
                                    <span>{feature.substr(0,1).toUpperCase() + feature.substr(1).toLowerCase().replace(/_/g,' ')}</span>
                                    {selections.indexOf(feature) !== -1 &&
                                        <div className="compare-button" style={divStyle}>
                                            <i className="fa fa-times" style={faStyle}></i>
                                        </div>}
                                </div>
                            })}
                        </Slider>
                    </div>
                </div>
            </div>
        ); */

        if(!features || features.length === 0){
            return null;
        }

        return (
            <div className="features_list">
                <Select
                    placeholder="Home Features [BETA]"
                    name="homeFeatures"
                    className="tru-dropdown-compact react-select-container full-height"
                    classNamePrefix="react-select"
                    isMulti={true}   
                    onChange={(e) => this.handleReactSelectChange(e, 'homeFeatures')}
                    value={selected}
                    options={features.map((f) => {
                        return { value: f, label: toProperCase(f) }
                    })}
                />
            </div>
        );
    }
}

const mapStateToProps = (state, props) => ({
    searchParameters_Redux: state.search.parameters
});

const mapDispatchToProps = dispatch => ({
    searchActions: bindActionCreators(searchActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(HomeFeatures);

//---------- styles -----------------------------
//-----------------------------------------------
/* const faStyle = {
    position: "relative",
    bottom: "2px",
    fontSize: "12px"
}

const divStyle = {
    width: "17px",
    height: "17px",
    marginLeft: "5px",
    background: "#6e6e6e"
} */